export const customSlotPropGetter = (date: any) => {
  return {
    className: 'special-day',
  };
};
